import { HttpErrorResponse } from "@angular/common/http";
import {
    ErrorHandler,
    inject,
    Injectable,
    isDevMode,
    NgZone
} from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import {
    ERROR_CODE_I18N_KEYS,
    ErrorCode,
    GENERIC_ERROR_I18N_KEY
} from "./error-codes";

@Injectable({
    providedIn: "root"
})
export class GlobalErrorHandler implements ErrorHandler {
    private readonly zone = inject(NgZone);
    private readonly transloco = inject(TranslocoService);

    handleError(error: unknown): void {
        // HTTP error
        if (error instanceof HttpErrorResponse) {
            return this.zone.run(() => {
                const code = error.error?.code as ErrorCode | undefined;
                const i18nKey =
                    (code && ERROR_CODE_I18N_KEYS[code]) ||
                    GENERIC_ERROR_I18N_KEY;
                const translated = this.transloco.translate(i18nKey);
                const fallback = error.error?.message ?? error.message;

                // TODO do actual logic (e.g. snackbar)
                console.error(translated, { code, raw: fallback });
            });
        }

        // Application error. Should never happen otherwise it means there is some logic error or unhandled error cases
        if (error instanceof Error) {
            console.error(error);
            return this.zone.run(() => {
                let message = `GENERIC_ERROR`;

                if (isDevMode()) {
                    // Show real error only in non-production environments
                    message = error.message;
                }

                // TODO do actual logic
                console.error(message);
            });
        }

        // Default
        console.error(error);
    }
}
